import { Box, Container, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import EngineeringIcon from "@mui/icons-material/Engineering";
import SpeedIcon from "@mui/icons-material/Speed";

const features = [
  {
    title: "High-Precision Engineering",
    icon: <PrecisionManufacturingIcon sx={{ fontSize: 50 }} />,
    desc: "Advanced fabrication backed by skilled engineers and modern machinery.",
  },
  {
    title: "Customized Fabrication",
    icon: <EngineeringIcon sx={{ fontSize: 50 }} />,
    desc: "Tailored manufacturing solutions engineered to your requirements.",
  },
  {
    title: "Reliable Performance",
    icon: <CheckCircleIcon sx={{ fontSize: 50 }} />,
    desc: "Built with durable materials ensuring long-term reliability.",
  },
  {
    title: "Fast Delivery & Execution",
    icon: <SpeedIcon sx={{ fontSize: 50 }} />,
    desc: "Streamlined production and logistics for timely delivery.",
  },
];

export default function WhyChooseUs() {
  return (
    <Box
      sx={{
        py: 8,
        background: "linear-gradient(135deg, #0d0f19, #111627, #0b0e18)",
        color: "#fff",
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h4"
          fontWeight="700"
          sx={{
            textAlign: "center",
            mb: 5,
            color: "#e3f2fd",
            letterSpacing: "0.5px",
            textShadow: "0px 0px 12px rgba(26,35,126,0.6)",
          }}
        >
          Why Choose Us
        </Typography>

        {/* Flexbox container */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 4,
          }}
        >
          {features.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: { xs: "100%", sm: "45%", md: "22%" },
                background: "rgba(255,255,255,0.06)",
                borderRadius: 4,
                p: 3,
                textAlign: "center",
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow: "0px 8px 30px rgba(0,0,0,0.45)",
                transition: "all 0.35s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  border: "1px solid rgba(26,35,126,0.6)",
                  boxShadow: "0px 12px 40px rgba(26,35,126,0.4)",
                },
              }}
            >
              {/* Icon */}
              <Box
                sx={{
                  color: "#90caf9",
                  mb: 2,
                  filter: "drop-shadow(0 0 10px rgba(26,35,126,0.7))",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </Box>

              {/* Title */}
              <Typography
                sx={{
                  fontSize: "1.2rem",
                  fontWeight: 700,
                  color: "#e3f2fd",
                  mb: 1,
                }}
              >
                {item.title}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  fontSize: "0.95rem",
                  color: "#cfd8dc",
                  lineHeight: 1.5,
                }}
              >
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
